import { classNames } from 'primereact/utils';
import { FormEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useChangeStatusMutation, useGetAuftraegeMutation, useTerminStornoMutation } from '../../api/AuftragAPI';
import { LoadingModal } from '../../component/LoadingModal/LoadingModal';
import { setListAuftragWithStatus, toggleSelectedAuftragIds } from '../../Slice/AllParameter';
import { AppDispatch, RootState } from '../../Store';
import { IAuftrag } from '../../types/Types';
import { formatToEuroDateTime } from '../../util/DateUtils';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import styles from './auftrag.module.scss';
import AuftragAnzeigeWiedervorlage from './AuftragAnzeigeWiedervorlage';
import AuftragTerminierenWrapper from './AuftragTerminierenWrapper';
import AuftragAnzeigeTerminiert from './AuftragAnzeigeTerminiert';

/**
 * @author noone
 */
export default function AuftragMain() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [getAuftraegAPI] = useGetAuftraegeMutation();
    const [terminStornoAPI] = useTerminStornoMutation();
    const [changeStatusAPI] = useChangeStatusMutation();

    const listauftragwithstatus = useSelector((state: RootState) => state.allParameter.listAuftragWithStatus);
    const googleToken = useSelector((state: RootState) => state.allParameter.googleToken);
    //const selectedAuftragIds = useSelector((state: RootState) => state.allParameter.selectedAuftragIds);

    const [auftragslisteGesamt, setAuftragslisteGesamt] = useState<IAuftrag[]>([]);
    const [auftragsliste, setAuftragsliste] = useState<IAuftrag[]>([]);
    const [s, setS] = useState<Map<string, number>>(new Map());

    const handleNextStatus = (uid: string, nextstatus: string) => {
        changeStatusAPI({ uid: uid, neuerStatus: nextstatus }).then(() => refresh());
    }

    const filterListe = () => {
        if (listauftragwithstatus === "IN_TERMINIERUNG")
            setAuftragsliste(auftragslisteGesamt.filter(a => a.status === "NEU" || a.status === "IN_TERMINIERUNG"));
        else
            setAuftragsliste(auftragslisteGesamt.filter(a => a.status === listauftragwithstatus));
    }

    const anzahlGruppiert = () => {
        const newMap = new Map<string, number>();
        auftragslisteGesamt.map((auftrag) => {
            var suchstatus = (auftrag.status === "NEU") ? "IN_TERMINIERUNG" : auftrag.status;
            var anzahl = newMap.get(suchstatus);
            if (anzahl === undefined)
                anzahl = 1;
            else
                anzahl = anzahl + 1;
            newMap.set(suchstatus, anzahl);
        });
        setS(newMap);
    }

    const stornoTermin = (uid: string) => {
        terminStornoAPI(uid).then(() => refresh());
    }

    const refresh = async () => {
        setIsLoading(true);
        await getAuftraegAPI().unwrap()
            .then(data => setAuftragslisteGesamt(data))
            .catch((e) => alert("" + e))
            .finally(() => setIsLoading(false) )
            ;
    }

    const statusChanged = () => {
        refresh();
    }

    const centerOnMap = (id: string) => {
    }

    useEffect(() => {
        filterListe();
        anzahlGruppiert();
    }, [auftragslisteGesamt]);

    useEffect(() => {
        filterListe();

        if (listauftragwithstatus === "IN_TERMINIERUNG")
            auftragsliste.map((e) =>
                dispatch(toggleSelectedAuftragIds(e)
                ));
    }, [listauftragwithstatus]);

    useEffect(() => {
        //console.log("google token:" + googleToken);
    }, [googleToken]);

    useEffect(() => {
        refresh();
    }, []);


    return (
        <div>

            <LoadingModal show={isLoading} />

            <LandingpageHeader />

            <div style={{ padding: "20px" }}>

                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <button
                        onClick={() => {
                            navigate({
                                pathname: "/",
                                search: ""
                            });
                        }}

                        style={{ marginBottom: "20px" }}
                        className=' btn btn-outline-primary'
                    >
                        <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
                    </button>

                    <button
                        onClick={() => {
                            navigate({
                                pathname: "./search",
                                search: ""
                            });
                        }}

                        style={{ marginBottom: "20px" }}
                        className=' btn btn-outline-primary'
                    >
                        Suche Auftrag <i className="bi bi-search"></i>
                    </button>
                </div>

                <h4 style={{ textAlign: "center" }}>Aufträge</h4>

                <div className={styles["auftragStatusBtnRow"]} >

                    <div className={(listauftragwithstatus === "IN_TERMINIERUNG") ? "btn btn-primary" : "btn btn-light"} onClick={() => dispatch(setListAuftragWithStatus("IN_TERMINIERUNG"))}>

                        <span className={styles["auftragStatusBtnRow_Content"]}>in Terminierung ( {s.get("IN_TERMINIERUNG") ? s.get("IN_TERMINIERUNG") : "-"} )</span>

                    </div>

                    <div className={(listauftragwithstatus === "WIEDERVORLAGE") ? "btn btn-primary" : "btn btn-light"} onClick={() => dispatch(setListAuftragWithStatus("WIEDERVORLAGE"))}>

                        <span className={styles["auftragStatusBtnRow_Content"]}>WIEDERVORLAGE ( {s.get("WIEDERVORLAGE") ? s.get("WIEDERVORLAGE") : "-"} )</span>

                    </div>

                    <div className={(listauftragwithstatus === "TERMINIERT") ? "btn btn-primary" : "btn btn-light"} onClick={() => dispatch(setListAuftragWithStatus("TERMINIERT"))}>

                        <span className={styles["auftragStatusBtnRow_Content"]}>Terminiert ( {s.get("TERMINIERT") ? s.get("TERMINIERT") : "-"} )</span>

                    </div>

                    <div className={(listauftragwithstatus === "FERTIG") ? "btn btn-primary" : "btn btn-light"} onClick={() => dispatch(setListAuftragWithStatus("FERTIG"))}>

                        <span className={styles["auftragStatusBtnRow_Content"]}>Gemessen ( {s.get("FERTIG") ? s.get("FERTIG") : "-"} )</span>

                    </div>

                </div>


                {listauftragwithstatus === "FERTIG" &&
                    <>
                        <div className={classNames(styles.auftragList)}>

                            {auftragsliste?.length === 0 && <div>Keine Aufträge vorhanden</div>}

                            <table className="table" style={{ width: "100%", marginTop: "20px" }}>
                                <thead>
                                    <tr>
                                        {(listauftragwithstatus === "FERTIG" &&
                                            <>
                                                <th></th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Stadt</th>
                                                <th scope="col">Zugeteilt</th>
                                            </>
                                        )}

                                    </tr>
                                </thead>
                                <tbody>
                                    {auftragsliste?.map((auftrag, index) => (
                                        <tr key={index}>

                                           
                                                <>
                                                    <td>{auftrag.art}</td>
                                                    <td>{auftrag.name_endkunde}</td>
                                                    <td>{auftrag.stadt_lieferadresse}</td>
                                                    <td>{auftrag.ausfuehrungvon?.name}</td>
                                                    <td>
                                                        <button title='Storno' className="btn btn-warning" onClick={() => handleNextStatus(auftrag.uid, "TERMINIERT")}><i className="bi bi-arrow-left"></i> Wieder auf terminiert</button>
                                                    </td>
                                                </>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                }

                 {listauftragwithstatus === "TERMINIERT" &&
                    <><AuftragAnzeigeTerminiert statusChanged={statusChanged} liste={auftragsliste} /></>
                }

                {listauftragwithstatus === "WIEDERVORLAGE" &&
                    <><AuftragAnzeigeWiedervorlage statusChanged={statusChanged} liste={auftragsliste} /></>
                }

                {listauftragwithstatus === "IN_TERMINIERUNG" &&
                    <><AuftragTerminierenWrapper statusChanged={statusChanged} liste={auftragsliste} /></>
                }

            </div>
            <Footer />
        </div >
    );

}

